import * as $ from 'jquery';
import { TransitApplication } from './TransitApplication';

$(() => {
    const transitContainer = $('[data-transit-form]');

    // If we are not on transit page we stop script
    if (transitContainer.length === 0) {
        return;
    }

    let container = $(transitContainer[0]);
    container.data('transitApp', new TransitApplication(container));
});
